import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=4ceb8957"
import script from "./Limit.vue?vue&type=script&lang=js"
export * from "./Limit.vue?vue&type=script&lang=js"
import style0 from "../../scss/base.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports